import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/use-auth.js';
import logo from '../img/logo-pilateshatyai.jpg';
import './home.css';
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import CallAPI from '../utils/call-api.js';

export default function Home() {
  const auth = useAuth();
  const navigate = useNavigate();

  const [credentials, setCredentials] = useState({
    phone: undefined,
    password: undefined
  });

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    const user = await auth.signin(credentials);
    if (user) {
      if (user.isAdmin) {
        navigate('/user');
      } else {
        navigate('/booking');
      }
    }
  };

  const handleChange = (evt) => {
    setCredentials((prev) => ({ ...prev, [evt.target.name]: evt.target.value }));
  };

  useEffect(() => {
    const validate = async () => {
      if (auth.user) {
        try {
          await CallAPI.get('/auth/validate');
          navigate('/booking');
        } catch (err) {
          auth.signout();
        }
      }
    };
    validate();
  }, []);

  return (
    <>
    <header>
      <div className="container">
        <div className="logo"><img src={logo} alt="Pilates Hatyai"/></div>
        <nav>
          <ul>
            {auth.user && <li><Link to="/booking">{!auth.user.isAdmin && 'จอง' }คลาส</Link></li>}
            {auth.user?.isAdmin &&
              <li><Link to="/user">ผู้ใช้งาน</Link></li>
            }
            {auth.user && !auth.user.isAdmin && <li><Link to="/schedule">ตารางเรียน</Link></li>}
            {auth.user ? <li><button onClick={auth.signout}><FontAwesomeIcon icon={faArrowRightFromBracket} /> ออก</button></li> : ''}
          </ul>
        </nav>
      </div>
    </header>
    <main>
      <div className="container">
        {!auth.user &&
          <form className="form-login" onSubmit={handleSubmit}>
            <div><input type="text" name="phone" placeholder="เบอร์โทร" onChange={handleChange}/></div>
            <div><input type="password" name="password" placeholder="รหัสผ่าน" onChange={handleChange}/></div>
            <div><button type="submit">เข้าสู่ระบบ</button></div>
          </form>
        }
        <Outlet />
      </div>
    </main>
    </>
  );
}
